import { TableSortLabel } from '@mui/material';
import type { TableColumn } from '../../tanstackTypes';

interface SortProps {
  column: TableColumn<any>;
}
export const Sort = ({ column }: SortProps) => {
  if (typeof column.getCanSort !== 'function' || !column.getCanSort()) {
    return null;
  }

  const direction = column.getIsSorted?.();

  return (
    <TableSortLabel
      active={direction !== false}
      direction={direction === 'desc' ? 'desc' : 'asc'}
    />
  );
};
